import { takeEvery } from "redux-saga/effects";
import { types } from "../../actions/courier";
import {
  getCourierZones,
  createCourierZone,
  updateCourierZone,
  deleteCourierZone,
  reorderCourierZones,
  getCourierCenters,
  createCourierCenter,
  updateCourierCenter,
  deleteCourierCenter,
  reorderCourierZoneCenters,
  getCouriers,
  createCourier,
  updateCourier,
  getCourierRounds,
  createCourierRound,
  updateCourierRound,
  deleteCourierRound,
  getCourierRoundStops,
  createCourierRoundStop,
  deleteCourierRoundStop,
  reorderCourierRoundStops,
  getCourierRoundSchedules,
  createCourierRoundSchedule,
  deleteCourierRoundSchedule,
  getCourierShifts,
  createCourierShift,
  deleteCourierShift,
  getCourierTrips,
  getCourierTripTasks,
  generateCourierTrips,
  getEligibleCouriers,
  assignCourierTrip,
  cancelCourierTrip,
  startCourierTrip,
  deliverCourierTrip,
  reachCourierTask,
  dispatchCourierTask,
  outcomeCourierTask,
  overrideGpsCourierTask,
  getCourierCustodyItems,
  createCourierCustodyItem,
  reconcileCourierCustodyItem,
  createCourierManualJob,
  getCourierReports,
  getCourierReport,
  getCourierLiveMonitor,
  optimizeRoundStops,
  autoAssignCourierTrip
} from "./courier";

export function* courierSaga() {
  yield takeEvery(types.GET_COURIER_ZONES_REQUEST, getCourierZones);
  yield takeEvery(types.CREATE_COURIER_ZONE_REQUEST, createCourierZone);
  yield takeEvery(types.UPDATE_COURIER_ZONE_REQUEST, updateCourierZone);
  yield takeEvery(types.DELETE_COURIER_ZONE_REQUEST, deleteCourierZone);
  yield takeEvery(types.REORDER_COURIER_ZONES_REQUEST, reorderCourierZones);

  yield takeEvery(types.GET_COURIER_CENTERS_REQUEST, getCourierCenters);
  yield takeEvery(types.CREATE_COURIER_CENTER_REQUEST, createCourierCenter);
  yield takeEvery(types.UPDATE_COURIER_CENTER_REQUEST, updateCourierCenter);
  yield takeEvery(types.DELETE_COURIER_CENTER_REQUEST, deleteCourierCenter);
  yield takeEvery(
    types.REORDER_COURIER_ZONE_CENTERS_REQUEST,
    reorderCourierZoneCenters
  );

  yield takeEvery(types.GET_COURIERS_REQUEST, getCouriers);
  yield takeEvery(types.CREATE_COURIER_REQUEST, createCourier);
  yield takeEvery(types.UPDATE_COURIER_REQUEST, updateCourier);

  yield takeEvery(types.GET_COURIER_ROUNDS_REQUEST, getCourierRounds);
  yield takeEvery(types.CREATE_COURIER_ROUND_REQUEST, createCourierRound);
  yield takeEvery(types.UPDATE_COURIER_ROUND_REQUEST, updateCourierRound);
  yield takeEvery(types.DELETE_COURIER_ROUND_REQUEST, deleteCourierRound);

  yield takeEvery(types.GET_COURIER_ROUND_STOPS_REQUEST, getCourierRoundStops);
  yield takeEvery(
    types.CREATE_COURIER_ROUND_STOP_REQUEST,
    createCourierRoundStop
  );
  yield takeEvery(
    types.DELETE_COURIER_ROUND_STOP_REQUEST,
    deleteCourierRoundStop
  );
  yield takeEvery(
    types.REORDER_COURIER_ROUND_STOPS_REQUEST,
    reorderCourierRoundStops
  );

  yield takeEvery(
    types.GET_COURIER_ROUND_SCHEDULES_REQUEST,
    getCourierRoundSchedules
  );
  yield takeEvery(
    types.CREATE_COURIER_ROUND_SCHEDULE_REQUEST,
    createCourierRoundSchedule
  );
  yield takeEvery(
    types.DELETE_COURIER_ROUND_SCHEDULE_REQUEST,
    deleteCourierRoundSchedule
  );

  yield takeEvery(types.GET_COURIER_SHIFTS_REQUEST, getCourierShifts);
  yield takeEvery(types.CREATE_COURIER_SHIFT_REQUEST, createCourierShift);
  yield takeEvery(types.DELETE_COURIER_SHIFT_REQUEST, deleteCourierShift);

  yield takeEvery(types.GET_COURIER_TRIPS_REQUEST, getCourierTrips);
  yield takeEvery(types.GET_COURIER_TRIP_TASKS_REQUEST, getCourierTripTasks);
  yield takeEvery(types.GENERATE_COURIER_TRIPS_REQUEST, generateCourierTrips);
  yield takeEvery(types.GET_ELIGIBLE_COURIERS_REQUEST, getEligibleCouriers);
  yield takeEvery(types.ASSIGN_COURIER_TRIP_REQUEST, assignCourierTrip);
  yield takeEvery(types.CANCEL_COURIER_TRIP_REQUEST, cancelCourierTrip);

  yield takeEvery(types.START_COURIER_TRIP_REQUEST, startCourierTrip);
  yield takeEvery(types.DELIVER_COURIER_TRIP_REQUEST, deliverCourierTrip);
  yield takeEvery(types.REACH_COURIER_TASK_REQUEST, reachCourierTask);
  yield takeEvery(types.DISPATCH_COURIER_TASK_REQUEST, dispatchCourierTask);
  yield takeEvery(types.OUTCOME_COURIER_TASK_REQUEST, outcomeCourierTask);
  yield takeEvery(
    types.OVERRIDE_GPS_COURIER_TASK_REQUEST,
    overrideGpsCourierTask
  );

  yield takeEvery(
    types.GET_COURIER_CUSTODY_ITEMS_REQUEST,
    getCourierCustodyItems
  );
  yield takeEvery(
    types.CREATE_COURIER_CUSTODY_ITEM_REQUEST,
    createCourierCustodyItem
  );
  yield takeEvery(
    types.RECONCILE_COURIER_CUSTODY_ITEM_REQUEST,
    reconcileCourierCustodyItem
  );
  yield takeEvery(
    types.CREATE_COURIER_MANUAL_JOB_REQUEST,
    createCourierManualJob
  );

  yield takeEvery(types.GET_COURIER_REPORTS_REQUEST, getCourierReports);
  yield takeEvery(types.GET_COURIER_REPORT_REQUEST, getCourierReport);
  yield takeEvery(
    types.GET_COURIER_LIVE_MONITOR_REQUEST,
    getCourierLiveMonitor
  );

  yield takeEvery(types.OPTIMIZE_ROUND_STOPS_REQUEST, optimizeRoundStops);
  yield takeEvery(
    types.AUTO_ASSIGN_COURIER_TRIP_REQUEST,
    autoAssignCourierTrip
  );
}
